import { ReactNode } from 'react';
import { Col, Row, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { StyledIconWrapper } from './styles';
import { StatsResponse } from 'types/common';
import Button from '../button/Button';

type CardType = 'default' | 'success' | 'warning' | 'error' | 'processing';

type Props = {
    type: CardType;
    icon: ReactNode;
    count: number | undefined;
    label: string;
    loading?: boolean;
    error?: boolean;
    onRefresh?: () => Promise<StatsResponse> | null;
};

const typesColorMap: Record<CardType, string> = {
    success: '#F6FFED',
    default: '#E6F7FF',
    error: '#FFF1F0',
    warning: '#FFF7E6',
    processing: '#EADFFF',
};

const StatsCard = ({ label, count, icon, type, error, loading, onRefresh }: Props) => {
    const color = typesColorMap[type];

    return (
        <Row
            style={{
                minWidth: 265,
                height: 90,
                border: '1px solid var(--gray-3)',
                borderRadius: 6,
                paddingInline: 24,
                background: `linear-gradient(90deg, #ffffff 0%, #ffffff 45%, ${color} 100%)`,
            }}
            justify="space-between"
            align="middle"
        >
            {error ? (
                <Col>
                    <Typography.Text style={{ color: 'var(--dust-red-5)' }}>Failed to get data</Typography.Text>
                    <div>
                        <Button onClick={onRefresh} style={{ color: 'var(--brand-6)' }} type="link">
                            Refresh
                        </Button>
                    </div>
                </Col>
            ) : loading ? (
                <Col>
                    <div>{label}</div>
                    <div style={{ fontSize: 24, fontWeight: 600 }}>
                        <LoadingOutlined />
                    </div>
                </Col>
            ) : (
                <Col>
                    <div>{label}</div>
                    <div style={{ fontSize: 24, fontWeight: 600 }}>{count}</div>
                </Col>
            )}

            <Col>
                <StyledIconWrapper>{icon}</StyledIconWrapper>
            </Col>
        </Row>
    );
};

export default StatsCard;
